// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').Backups} Backups
 * @typedef {import('../types/system').BackupFolder} BackupFolder
 */

/**
 * @type {function(PlottrState): Backups}
 */
const backupsSelector = createSelector(fullSystemStateSelector, ({ backups }) => {
  return backups ?? { folders: [] }
})

/**
 * @type {function(PlottrState): Array<BackupFolder>}
 */
export const backupFoldersSelector = createSelector(backupsSelector, ({ folders }) => {
  return folders
})

/**
 * @type {function(PlottrState): Array<BackupFolder>}
 */
export const nonEmptyBackupFoldersSelector = createSelector(
  backupFoldersSelector,
  (backupFolders) => {
    return backupFolders.filter(({ backups }) => {
      return backups.length > 0
    })
  }
)
